import { HttpClient, HttpContext } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  CreatePromotionPayload,
  Promotion,
  PromotionStatus,
} from '../../shared/interfaces';
import { API_BASE_URL } from '../../shared/api/api.tokens';
import { REQUIRE_AUTH } from '../../shared/interceptors/auth-context';

@Injectable({ providedIn: 'root' })
export class PromotionsService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = inject(API_BASE_URL);

  listPromotions(businessId: string, status?: PromotionStatus) {
    const params = status ? { status } : undefined;
    return this.http.get<Promotion[]>(
      `${this.baseUrl}/api/v1/businesses/${businessId}/promotions`,
      {
        params,
        context: new HttpContext().set(REQUIRE_AUTH, true),
      }
    );
  }

  createPromotion(businessId: string, payload: CreatePromotionPayload): Observable<{ id: string }> {
    return this.http.post<{ id: string }>(
      `${this.baseUrl}/api/v1/businesses/${businessId}/promotions`,
      payload,
      {
        context: new HttpContext().set(REQUIRE_AUTH, true),
      }
    );
  }

  updatePromotion(
    businessId: string,
    promotionId: string,
    payload: CreatePromotionPayload
  ): Observable<{ message: string }> {
    return this.http.put<{ message: string }>(
      `${this.baseUrl}/api/v1/businesses/${businessId}/promotions/${promotionId}`,
      payload,
      {
        context: new HttpContext().set(REQUIRE_AUTH, true),
      }
    );
  }

  updateStatus(
    businessId: string,
    promotionId: string,
    status: PromotionStatus
  ): Observable<{ message: string }> {
    return this.http.put<{ message: string }>(
      `${this.baseUrl}/api/v1/businesses/${businessId}/promotions/${promotionId}/status`,
      { status },
      {
        context: new HttpContext().set(REQUIRE_AUTH, true),
      }
    );
  }

  deletePromotion(businessId: string, promotionId: string) {
    return this.http.delete<{ message: string }>(
      `${this.baseUrl}/api/v1/businesses/${businessId}/promotions/${promotionId}`,
      {
        context: new HttpContext().set(REQUIRE_AUTH, true),
      }
    );
  }
}
